//使用格式说明：
//1、带参数：已更新{parm}讲，参数位置可以调整，ag:Updated Lecture {parm}
const en = {
    public: {
        moneyUnit:'USD',
        nodata: 'No Data',
        share:"Share",
        orderNumber:"Order Number",
        remark:"Remark",
        save:"Save",
        vcode:"Enter Verification Code",
        getCode:"Get Verification Code",
        inputPhone:"Enter Phone Number",
        detail:"Detail",
        hour:"h",
        minute:"mn",
        second:"s",
        again:'{parm}s',
        sex_1:"Male",
        sex_2:"Female",
        sex_3:"Secret",
        payTitle:'Enter Payment Passcode',
        payMethod:'Payment Method',
        paySmall :'Balance',
        cancel :'Cancel',
        send:'Sent to:',
        verifyId:'ID Verification',
        loginRegister:'Register',
        selectArea:'Area',
        contactus:'Contact Us',
        pageViews:"{parm} Views",
        pageViews_1:"Views {parm}",
        rebate:"{parm}% off",
        ok:'Okay',
        get:'{parm} Get {parm_1}',
        close:'Close',
        service:'Service'
    },
    pull:{
        loading:'Loading...',
        swipe:'Swipe',
        release:'Release'
    },
    tabbar:{
        home:'Home',
        assort:'Mall',
        points:'My Box',
        mine:'Account'
    },
    pay:{
        key_1:"Balance payment",
        key_2:"Balance：",

    },
    index: {
        key_1:'Max Discount$',
        key_2:'Limit Sale{parm}%oFF',
        key_4:'I know',
        key_6:'After get Coupons',
        key_7:'Some boxes can be used',
        key_8:'All boxes can be used',
        key_9:'Total purchase ${parm} can use',
        key_10:'Total pay ${parm} can use for some boxes',
        key_11:'Total pay ${parm} can use for all boxes',
        key_12:'Get Now',
        key_13:'Use Now',
        key_14:'Collect All',
        key_15:'Come Again Tomorrow',
        key_16:'Join Now',
        key_17:'Choose Coupon',
        key_18:'No Thresholds',
        key_20:'Valid till{parm}',
        key_21:'Confirm Order',
        key_22:'{parm}coupons can use',
        key_23:'Coupons',
        key_24:'Try again get discount',
        key_25:'Total Discount:',
        key_26:'Pay Now',
        key_27:'Service agreement and policy ',
        key_28:'Reminding Payment',
        key_29:'Pay with Balance, Click Pay Now to Confirm',
        key_30:'Pay Now',
        key_31:'WOW NOW',
        key_39:'The payment is successfully deducted,Continue?',
        key_40:'Coin Exchange:',
        key_41:'Pay with Coin',
        key_42:'Available Coin:',
        key_43:'Exchange Coin',
    },
    boxdetail:{
        key_1:'Value: ',
        key_2:'100% Satifaction/Easy Exchange/Worldwide Delivery',
        key_3:'See All',
        key_4:'This site is designed for users over age of 13',
        key_5:'Get Surprise',
        key_6:'Details',
        key_7:'Open Box to get one of these items',
        key_8:'Total: {parm} products({parm_1} pc{parm_2})'/* Total 10(10 Titan/Platinum) */
    },
    box:{
        key_1:'View My Box',
        key_2:'One more time',
        key_3:'Exchangeable:',
        key_4:'Coin',
        key_5:'Reminding: Please collect item before <i>{parm}</i> Otherwise item can only exchange coin',
        key_6:'Redeem',
        key_7:'Pick up',
        key_8:'Products',
        key_9:'My Box',
        key_10:'Open now',
        key_11:'<p>Exchange Note: </p><p>1.Item can be exchange into coin</p><p>2.Exchanged coin can use to purchange product in Mall</p><p>3.Coin can not transfer or withdraw</p><p>4.Contact customer service for more information</p>',
        key_12:'Total:{parm} pcs',
        key_13:'Total:',
        key_14:'Exchange',
        key_15:'Exchange Note',
        key_16:'After exchange coin can not undo, Do you want to Exchange?',
        key_18:'Successfully exchanged',
        key_19:'Received{parm}coin',
        key_20:'Back to My Box',
        key_21:'Select product',
        key_22:'Confirm order',
        key_23:'Enter your shipping address',
        key_24:'Delivery option',
        key_25:'Free delivery',
        key_26:'Coupons',
        key_27:'No Coupons',
        key_28:'Note',
        key_29:'Say something to Seller',
        key_30:'Submit order',
        key_31:"Your box don't have suitable products！",
        key_32:'Pick up reminder',
        key_33:'We will create order for you, Go to <Account> <My order> to view item, Continue?',
        key_34:'Order created！ View item in <My order>.',
        key_35:'Select item to pick up',
        key_36:'Select All',
        key_37:'Sellected <i>{parm}</i> pcs',
        key_38:'Pick Up Now',
      


    },
    mall:{
        key_1:'My Coin',
        key_2:'All',
        key_3:'More than{parm}',
        key_4:'Service',
        key_5:'Buy Now',
        key_6:'Exchange',
        key_7:'Stock:',
        key_8:'Quantity',
        key_9:'(Limit purchase{parm} pcs)',
        key_10:'Buy Now',
        key_11:'Select Options',
        key_12:'Confirm Order',
        key_13:'Add Shipping Address',
        key_14:'Delivery Options',
        key_15:'Free Delivery',
        key_16:'Coupons',
        key_17:'No coupons',
        key_18:'Note:',
        key_19:'Say somthing to Seller',
        key_20:'Total:{parm} pcs',
        key_21:'Total:',
        key_22:'Pay Now',
        key_23:'Pay with Coin',
        key_24:'Pay with Balance',
        key_25:' to continue Click <Okay>',
        key_26:'Paid Sucessfully！',
        key_27:'My Order',
        key_28:'Order Number:',
        key_29:'Delete Rrder',
        key_30:'Order Details',
        key_31:'All',
        key_32:'To Pay',
        key_33:'To Delivery',
        key_34:'Completed',
        key_35:'Done',
        key_36:'Delete Remind',
        key_37:'Are you sure to delete order? Continue?',
        key_38:'Payment Options',
        key_39:'Exchange Coin',
        key_40:'Order ID',
        key_41:'Order Time',
        key_42:'Paid Time',
        key_43:'Delivery Time',
        key_44:'Complete Time',
        key_45:'Buyer Note',
        key_46:'Confirm Received Order',
        key_47:'Receive Oder Reminding',
        key_48:'Are you sure you  already received item? Click to confirm',
        key_49:'Confirmed Receive',
        key_50:'Deleted',
        key_51:'All',
        key_52:'Price',
        key_53:'Coin',
    },
    coupon:{
        key_1:"Coupons",
        key_2:"No Threshold",
        key_3:'Total pay${parm} can use',
        key_4:"Valid till {parm}",
        key_5:"Use Now",
        key_6:"Not Used",
        key_7:"Used",
        key_8:"Expired",
    },
    address:{
        key_1:"My Address",
        key_2:"Set as Default",
        key_3:"Edit",
        key_4:"Delete",
        key_5:"Add Address",
        key_6:"Reminding",
        key_7:"Delete address can not recovered, Continue?",
        key_8:"Edit Address",
        key_9:"Receiver:",
        key_10:"Enter Contact Person",
        key_11:"Phone Number:",
        key_12:"Enter Phone Number",
        key_13:"City:",
        key_14:"Details Address:",
        key_15:"Set as Default"

    },
    about:{
        key_1:"About",
        key_2:"Current Version",
        key_3:"Update Version",
        key_4:"This is the latest version"
    },
    account:{
        key_1:"My Account",
        key_2:"Transfer",
        key_3:"Balance",
        key_4:"Top-up",
        key_5:"Transactions",
        key_6: "Withdrawal",
        key_7: "Withdrawal History",
        key_9: "Earnings History",
        key_10: "My Earnings",
        key_11: "Today",
        key_12: "This month",
        key_13: "Last month",
        key_14:'Pull up to Refresh'

    },
    bindphone:{
        key_1:"Connect",
        key_2:"Phone Number",
        key_3:"New Phone Number",
        key_4:"Change",
        key_5:"Current Phone Number",
        key_6:"Changing new pobile phone number will not affect your VIP , Balance and purchased history",
        key_7:"Enter New Phone Number",
        key_8:"Change Phone Number",
        key_9:"User Already Exists",
        key_10:"Please change another phone number or contact us to change",
        key_11:"Enter Verification Code",

    },
    cPassword:{
        key_1:"Change Password",
        key_2:"Old Password",
        key_3:"Enter Old Password",
        key_4:"New Password",
        key_5:"Confirm Password",
        key_6:"Enter New Password",
        key_7:'Password must be 8~20 character included letter and number',
        key_8:"Enter Password",
        key_9:'Enter Password Again',
    },
    editname:{
        key_1:"Change Name",
        key_2:"Enter Name",
        key_3:"Please Enter Your Name",
    },
    help:{
        key_1:"Help"
    },
    incomedetail:{
        key_1:"Transactions",
        key_2:"Receive Amount",
        key_3:"Transfer Amount",
        key_4:"Type",
        key_5:"Income",
        key_6:"Expense",
        key_7:"Time",
        key_8:"Transaction ណumber",
        key_9:"Amount",
        key_10:"Remark"
    },
    invite:{
        key_1:"Invited History",
        key_2:"Invite Banner",
        key_3:"Copy Code and Send to Friends",
        key_4:"Copied to Clipboard!"
    },
    login:{
        key_1:"Register",
        key_2:"Log in",
        key_3:"Enter Password",
        key_4:"Forget Password?",
        key_5:"By Clicking Register, You're aggreed with",
        key_6:"Terms & Condition",
        key_7:"Log in",
        key_8:"Enter Account Number",
        key_9:"Enter Password",
        key_10:"Please Wait...",
        key_11:"Invite Code",
        key_12:"Already a member? Log in now",
        key_13:"Confirm",
        key_14:"Please Wait...",
        key_15:"Processing...",
        key_16:"Change Password",
    },
    mine:{
        key_1:"Log in/Register",
        key_2:"Edit Profile",
        key_3:"My Balance",
        key_4:"My Coin",
        key_5:"Products",
        key_6:"My Boxes",
        key_7:"My App",
        key_8:"Coupons",
        key_9:"My Address",
        key_10:"Help",
        key_11:"Friends",
        key_12:"Check in to open Surprise Box",
        key_13:"My Orders",
        key_14:"All Orders",
        key_15:"To Pay",
        key_16:"To Deliver",
        key_17:"Completed",
        key_18:"Completed",
    },
    notice:{
        key_1:"Message",
        key_2:"Annoucement",
        key_3:"Play All",
        key_4:"See All"
    },
  
    recharge:{
        key_1:"Top-Up",
        key_2:"Notice: Please Upload Receipt",
        key_3:"Transfer Amount",
        key_4:"Please enter amount on Receipt",
        key_5:"Submit",
        key_6:"Need Help? Click Here! ",
        key_7:"Upload",
        key_8:"Receipt",
        key_9:"Transfer To: ",
        key_10:"Bank Name",
        key_11:"Account Name",
        key_12:"Account Number",
        key_13:"Switch Bank",
        key_14:"The Currently Bank",
        key_15:"Select Bank",
        key_16:"Enter amount！",
        key_17:"Please upload Receipt！",
        key_18:"Does confirm that the above account name is consistent with the ID card?",
        key_19:"Yes",
        key_20:"Verified"
    },
   
    setPaypaswd:{
        key_1:"Set Payment Passcode",
        key_2:"Passcode",
        key_3:"Enter New Password",
        key_4:"Phone Number",
        key_5:"Set Payment Passcode",
        key_6:"Click 'Set up Now' or Go to 'My Account'-->'Personal Info'-->'Payment passcode' to set up Payment passcode.",
        key_7:"Set Up Now",
        key_8:"Cancel",
        key_9:"Set payment password for payment verification"
    },
    setting:{
        key_1:"Profile Information",
        key_2:"Profile Picture",
        key_3:"Name",
        key_4:"Sex",
        key_5:"Change Password",
        key_6:"Edit",
        key_7:"Connect Phone number",
        key_8:"Connected",
        key_9:"Not Connected",
        key_10:"Payment Passcode",
        key_11:"Already Set",
        key_12:"Not Set",
        key_13:"Exit",
        key_14:"Sellect Sex",
        key_15:"Set",
        key_16:"About Us",
        key_17:"Language",
        key_18:"Account and Security",
        key_19:"Exit Reminding",
        key_20:"You're trying to Exit, Click Confirm to Continue",
    },
    security:{
        key_1:"Introduction",
        key_2:"For Securities, Go to set up your Log in Password",
        key_3:"Set Up Now",
        key_4:"Remind Me Later"
    },
 
    transfer:{
        key_1:"Transfer",
        key_2:"Notice: You can not return or undo after you transfer. Please check information carefully! ",
        key_3:"Receiver Account ",
        key_4:"Remark",
        key_5:"Transfer Amount",
        key_6:"Balance: ",
        key_7:"Transfer All",
        key_8:"Transfer",
        key_9:"Need Help? Click Here!",
        key_10:"Enter Account Number and Transfer Amount"
    },

    withdraw:{
        key_1: "Withdraw",
        key_2: "Withdrawal Amount",
        key_3: "Balance",
        key_4: "Withdraw All",
        key_5: "Submit",
        key_6: "Bank Name",
        key_7: "Account Number",
        key_8: "Account Name",
        key_9: "Receiver",
        key_10: "Bank Card",
        key_11: "Review within 24 hours",
        key_12: "Please Connect Your Bank Account",

    },

   
    integral:{
        title:"Mall",
        key_1:"All Categories",
        key_2:"Sold: {parm}",
        key_3:"Remain: {parm}",
        key_4:"Views",
        key_5:"Details",
        key_6:"Exchange",
        key_7:"Reward",
        key_8:"Details",
        key_9:"My Coin",
        key_10:"My VIP",
        key_11:"Coin",
        key_12:"Go",
        key_13:"Get Coin",
        key_14:"See You Tomorrow",
        key_15:" Congratulations!",
        key_16:" Exchange",
        key_17:" To Deliver",
        key_18:" Completed",
        key_19:" Order Number",
        key_20:" Total",
        key_21:" Order Details",
        key_22:" Order Number",
        key_23:" Order Time",
        key_24:" Exchange Time",
        key_25:" Total: {parm}",
        key_26:" Exchange Coin",
        key_27:" Submit",
        key_28:" Payment Methods",
        key_29:" Pay with Coin",
        key_30:" Total",
        key_31:" Confirm",
        key_32:" Exchange",
        key_33:" Are you sure to use Coin to Pay? Click Confirm",
        key_34:" Confirm",
        key_35:" Details",  
        key_36:" Available Coin",
        key_37:" Get Coin",
        key_38:" History",
        key_39:" Check in <i>{parm}</i> days ",
        key_40:" Check in",
        key_41:" New Products",
        key_42:" Go to Store",
    },
    transferpoints:{
        title:"Exchange Coin",
        key_1:" Exchange Amount",
        key_2:" Exchange All",
        key_3:" Confirm",
        key_4:" Enter Amount",
        key_5:" Remark",
        key_6:" After proceed, you can not exchange back! Confirm?",
        key_7:" Current Exchange Rate <i class='ratio'>1:{parm}</i>"
        
    }
  

    

}
 
export default en


// WEBPACK FOOTER //
// ./src/lang/pack/en.js